// Permissions of the logged in client user. The backend is the single source of truth:
// it returns `permissions` on login and on `web/profile`, and the main client always gets all of them.
const getUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userData")) || {};
  } catch (e) {
    return {};
  }
};

export const getPermissions = () => getUserData().permissions || null;

export const can = (permission) => {
  const permissions = getPermissions();
  // sessions opened before permissions existed: only the main client (role 1) has access until the profile refreshes
  if (!permissions) return getUserData().role == 1;
  return permissions[permission] === true;
};

export const savePermissions = (permissions, customPermissions) => {
  const userData = getUserData();
  if (!permissions || !userData.token) return;
  userData.permissions = permissions;
  userData.customPermissions = customPermissions;
  localStorage.setItem("userData", JSON.stringify(userData));
};
